import _classCallCheck from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { addUniqueItem, removeItem } from '../../utils/array.mjs';
var NodeStack = /*#__PURE__*/function () {
  function NodeStack() {
    _classCallCheck(this, NodeStack);
    this.members = [];
  }
  _createClass(NodeStack, [{
    key: "add",
    value: function add(node) {
      addUniqueItem(this.members, node);
      node.scheduleRender();
    }
  }, {
    key: "remove",
    value: function remove(node) {
      removeItem(this.members, node);
      if (node === this.prevLead) {
        this.prevLead = undefined;
      }
      if (node === this.lead) {
        var prevLead = this.members[this.members.length - 1];
        if (prevLead) {
          this.promote(prevLead);
        }
      }
    }
  }, {
    key: "relegate",
    value: function relegate(node) {
      var indexOfNode = this.members.findIndex(function (member) {
        return node === member;
      });
      if (indexOfNode === 0) return false;
      /**
       * Find the next projection node that is present
       */
      var prevLead;
      for (var i = indexOfNode; i >= 0; i--) {
        var member = this.members[i];
        if (member.isPresent !== false) {
          prevLead = member;
          break;
        }
      }
      if (prevLead) {
        this.promote(prevLead);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "promote",
    value: function promote(node, preserveFollowOpacity) {
      var _a;
      var prevLead = this.lead;
      if (node === prevLead) return;
      this.prevLead = prevLead;
      this.lead = node;
      node.show();
      if (prevLead) {
        prevLead.instance && prevLead.scheduleRender();
        node.scheduleRender();
        node.resumeFrom = prevLead;
        if (preserveFollowOpacity) {
          node.resumeFrom.preserveOpacity = true;
        }
        if (prevLead.snapshot) {
          node.snapshot = prevLead.snapshot;
          node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
        }
        if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
          node.isLayoutDirty = true;
        }
        var crossfade = node.options.crossfade;
        if (crossfade === false) {
          prevLead.hide();
        }
        /**
         * TODO:
         *   - Test border radius when previous node was deleted
         *   - boxShadow mixing
         *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
         *   - Shared between element A in transformed container and element B (transform stays the same or changes)
         *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
         * ---
         *   - Crossfade opacity of root nodes
         *   - layoutId changes after animation
         *   - layoutId changes mid animation
         */
      }
    }
  }, {
    key: "exitAnimationComplete",
    value: function exitAnimationComplete() {
      this.members.forEach(function (node) {
        var _a, _b, _c, _d, _e;
        (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
      });
    }
  }, {
    key: "scheduleRender",
    value: function scheduleRender() {
      this.members.forEach(function (node) {
        node.instance && node.scheduleRender(false);
      });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
  }, {
    key: "removeLeadSnapshot",
    value: function removeLeadSnapshot() {
      if (this.lead && this.lead.snapshot) {
        this.lead.snapshot = undefined;
      }
    }
  }]);
  return NodeStack;
}();
export { NodeStack };